import { render, staticRenderFns } from "./Panels.vue?vue&type=template&id=4f2ea5ce&"
import script from "./Panels.vue?vue&type=script&lang=ts&"
export * from "./Panels.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports